document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-orn-menu-toggle]');
  var menu = document.querySelector('[data-orn-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      });
    });
  }

  var navPanels = Array.prototype.slice.call(document.querySelectorAll('.or3-nav-panel'));

  navPanels.forEach(function (panel) {
    panel.addEventListener('toggle', function () {
      if (!panel.open) return;

      navPanels.forEach(function (otherPanel) {
        if (otherPanel !== panel) {
          otherPanel.open = false;
        }
      });
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.or3-nav-panel')) return;

    navPanels.forEach(function (panel) {
      panel.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    navPanels.forEach(function (panel) {
      panel.open = false;
    });
  });

  function runWhenVisible(element, callback) {
    var hasRun = false;

    function run() {
      if (hasRun) return;
      hasRun = true;
      callback();
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        run();
      });
    }, { rootMargin: '360px 0px' });

    observer.observe(element);
  }

  var params = new URLSearchParams(window.location.search);
  var species = params.get('species') || params.get('product') || params.get('plant');

  if (species) {
    document.querySelectorAll('[data-orn-species-field]').forEach(function (field) {
      field.value = species;
    });
  }

  document.querySelectorAll('[data-orn-file-input]').forEach(function (input) {
    var form = input.closest('form');
    var label = form ? form.querySelector('[data-orn-file-label]') : null;
    var field = form ? form.querySelector('[data-orn-file-list-field]') : null;
    var mailto = form ? form.querySelector('[data-orn-file-mailto]') : null;
    var drop = form ? form.querySelector('[data-orn-file-drop]') : null;

    function fileNames(files) {
      return Array.prototype.slice.call(files || []).map(function (file) {
        return file.name;
      }).filter(Boolean);
    }

    function update(files) {
      var names = fileNames(files);
      var summary = names.length ? names.join(', ') : 'No file selected yet';
      if (label) label.textContent = summary;
      if (field) field.value = names.length ? summary : '';
      if (mailto) {
        var body = names.length ? 'Plant schedule files selected on the website: ' + summary + '\n\nPlease attach the files to this email before sending.' : 'Please attach the plant schedule, drawings or specification files for review.';
        mailto.href = 'mailto:sales@ornatecinternational.com?subject=Plant%20schedule%20for%20Ornatec%20review&body=' + encodeURIComponent(body);
      }
    }

    input.addEventListener('change', function () {
      update(input.files);
    });

    if (drop) {
      drop.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        input.click();
      });

      ['dragenter', 'dragover'].forEach(function (eventName) {
        drop.addEventListener(eventName, function (event) {
          event.preventDefault();
          drop.classList.add('is-dragging');
        });
      });

      drop.addEventListener('dragleave', function (event) {
        event.preventDefault();
        drop.classList.remove('is-dragging');
      });

      drop.addEventListener('drop', function (event) {
        event.preventDefault();
        drop.classList.remove('is-dragging');

        if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
          try {
            input.files = event.dataTransfer.files;
          } catch (error) {
            // Some browsers keep file inputs read-only; the visible filename still updates.
          }
          update(event.dataTransfer.files);
        }
      });
    }
  });

  document.querySelectorAll('[data-or9-conversion-bar]').forEach(function (bar) {
    var dismiss = bar.querySelector('[data-or9-conversion-dismiss]');
    var storageKey = 'ornatecConversionBarDismissed';

    try {
      if (sessionStorage.getItem(storageKey) === '1') {
        bar.hidden = true;
      }
    } catch (error) {}

    if (dismiss) {
      dismiss.addEventListener('click', function () {
        bar.hidden = true;
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (error) {}
      });
    }
  });

  document.querySelectorAll('[data-orn-map]').forEach(function (map) {
    var buttons = Array.prototype.slice.call(map.querySelectorAll('.or5-map__point'));
    var kicker = map.querySelector('[data-orn-map-kicker]');
    var title = map.querySelector('[data-orn-map-title]');
    var copy = map.querySelector('[data-orn-map-copy]');
    var meta = map.querySelector('[data-orn-map-meta]');

    function activate(button) {
      buttons.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
      });

      if (kicker) kicker.textContent = button.dataset.mapKicker || '';
      if (title) title.textContent = button.dataset.mapTitle || '';
      if (copy) copy.textContent = button.dataset.mapCopy || '';
      if (meta) meta.textContent = button.dataset.mapMeta || '';
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activate(button);
      });
    });
  });

  document.querySelectorAll('[data-orn-network-map]').forEach(function (map) {
    var markers = Array.prototype.slice.call(map.querySelectorAll('[data-network-marker]'));
    var filters = Array.prototype.slice.call(map.querySelectorAll('[data-network-filter]'));
    var listItems = Array.prototype.slice.call(map.querySelectorAll('[data-network-list-item]'));
    var kicker = map.querySelector('[data-network-kicker]');
    var title = map.querySelector('[data-network-title]');
    var copy = map.querySelector('[data-network-copy]');
    var meta = map.querySelector('[data-network-meta]');
    var activeFilter = 'all';

    function markerMatches(marker) {
      return activeFilter === 'all' || (marker.dataset.networkGroup || '').split(' ').indexOf(activeFilter) !== -1;
    }

    function activate(marker) {
      markers.forEach(function (item) {
        item.classList.toggle('is-active', item === marker);
      });
      listItems.forEach(function (item) {
        item.classList.toggle('is-active', item.dataset.networkTarget === marker.dataset.networkTitle);
      });
      if (kicker) kicker.textContent = marker.dataset.networkKicker || '';
      if (title) title.textContent = marker.dataset.networkTitle || '';
      if (copy) copy.textContent = marker.dataset.networkCopy || '';
      if (meta) meta.textContent = marker.dataset.networkMeta || '';
    }

    function applyFilter(filter) {
      activeFilter = filter;
      filters.forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.networkFilter === filter);
      });
      markers.forEach(function (marker) {
        marker.hidden = !markerMatches(marker);
      });
      var firstVisible = markers.find(markerMatches);
      if (firstVisible) activate(firstVisible);
    }

    markers.forEach(function (marker) {
      marker.addEventListener('click', function () {
        activate(marker);
      });
    });

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(button.dataset.networkFilter || 'all');
      });
    });

    listItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var marker = markers.find(function (entry) {
          return entry.dataset.networkTitle === item.dataset.networkTarget;
        });
        if (marker) {
          if (marker.hidden) applyFilter('all');
          activate(marker);
        }
      });
    });
  });

  document.querySelectorAll('[data-orn-globe]').forEach(function (globe) {
    var canvas = globe.querySelector('[data-globe-canvas]');
    var context = canvas ? canvas.getContext('2d') : null;

    if (!canvas || !context) return;

    var filters = Array.prototype.slice.call(globe.querySelectorAll('[data-globe-filter]'));
    var zoomControls = Array.prototype.slice.call(globe.querySelectorAll('[data-globe-zoom]'));
    var buttons = Array.prototype.slice.call(globe.querySelectorAll('[data-globe-point]'));
    var panel = globe.querySelector('.or7-globe__panel');
    var countrySource = globe.dataset.countrySource;
    var kicker = panel ? panel.querySelector('[data-globe-kicker]') : null;
    var title = panel ? panel.querySelector('[data-globe-title]') : null;
    var copy = panel ? panel.querySelector('[data-globe-copy]') : null;
    var meta = panel ? panel.querySelector('[data-globe-meta]') : null;
    var activeLabel = globe.querySelector('[data-globe-active-label]');
    var pointMap = {};
    var state = {
      active: null,
      centerLng: 82,
      centerLat: 14,
      filter: 'all',
      width: 0,
      height: 0,
      radius: 0,
      zoom: 1,
      cx: 0,
      cy: 0,
      dragging: false,
      hasMoved: false,
      hover: false,
      lastX: 0,
      lastY: 0
    };
    var filterViews = {
      all: { lng: 82, lat: 14, zoom: 1 },
      projects: { lng: 86, lat: 25, zoom: 1.12 },
      supply: { lng: 112, lat: -2, zoom: 1.1 },
      markets: { lng: 56, lat: 25, zoom: 1.28 }
    };
    var globeCountries = [];

    var points = buttons.map(function (button) {
      var point = {
        button: button,
        title: button.dataset.globeTitle || button.textContent.trim(),
        label: button.dataset.globeLabel || '',
        type: button.dataset.globeType || 'project',
        group: button.dataset.globeGroup || '',
        lat: parseFloat(button.dataset.globeLat || '0'),
        lng: parseFloat(button.dataset.globeLng || '0'),
        kicker: button.dataset.globeKicker || '',
        copy: button.dataset.globeCopy || '',
        meta: button.dataset.globeMeta || '',
        x: 0,
        y: 0,
        visible: false,
        matches: true
      };
      pointMap[point.title] = point;
      return point;
    });

    var networkToggle = globe.querySelector('[data-globe-network-toggle]');

    if (networkToggle) {
      function setNetworkOpen(isOpen) {
        globe.classList.toggle('is-network-open', isOpen);
        networkToggle.setAttribute('aria-expanded', String(isOpen));
        networkToggle.textContent = isOpen ? 'Hide project and supply points' : 'Browse project and supply points';
      }

      setNetworkOpen(false);

      networkToggle.addEventListener('click', function () {
        setNetworkOpen(!globe.classList.contains('is-network-open'));
      });

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (window.matchMedia('(max-width: 760px)').matches) {
            setNetworkOpen(false);
          }
        });
      });
    }

    var routes = [
      ['Utchee Creek, Queensland', 'Red Sea Global'],
      ['Guangdong production network', 'Red Sea Global'],
      ['Thailand staging hub', 'Red Sea Global'],
      ['Malaysia supplier access', 'Red Sea Global'],
      ['Vietnam supplier access', 'Red Sea Global'],
      ['Philippines supplier access', 'Red Sea Global'],
      ['Utchee Creek, Queensland', 'AMAALA Resorts'],
      ['Thailand staging hub', 'AMAALA Resorts'],
      ['Guangdong production network', 'Wynn Al Marjan Island'],
      ['Thailand staging hub', 'Wynn Al Marjan Island'],
      ['Guangdong production network', 'Disneyland Shanghai'],
      ['Guangdong production network', 'Disneyland Hong Kong'],
      ['Guangdong production network', 'Wynn Palace Casino Macau'],
      ['Utchee Creek, Queensland', 'Japan']
    ];

    var landMasses = [
      { name: 'Europe', points: [[72, -10], [70, 28], [62, 45], [52, 42], [45, 34], [38, 29], [36, 17], [43, 4], [52, -6], [62, -10]] },
      { name: 'North Africa', points: [[36, -17], [34, 33], [23, 38], [9, 42], [-12, 40], [-34, 25], [-35, 18], [-24, 10], [-5, 5], [12, -6], [27, -12]] },
      { name: 'Arabia', points: [[32, 35], [30, 48], [26, 56], [18, 57], [12, 52], [12, 44], [17, 39], [25, 35]] },
      { name: 'West Asia', points: [[42, 32], [43, 58], [35, 64], [29, 58], [30, 45], [36, 36]] },
      { name: 'India', points: [[30, 68], [29, 82], [22, 88], [13, 84], [7, 78], [13, 72], [22, 68]] },
      { name: 'China', points: [[51, 75], [49, 100], [43, 122], [32, 124], [22, 111], [23, 96], [30, 84], [40, 76]] },
      { name: 'Southeast Asia', points: [[23, 96], [20, 106], [16, 109], [11, 103], [7, 101], [5, 106], [10, 112], [6, 118], [-2, 110], [4, 99]] },
      { name: 'Malaysia and Borneo', points: [[6, 100], [2, 104], [1, 112], [-5, 116], [-7, 108], [-2, 101]], holes: [[[3, 113], [2, 119], [-3, 119], [-4, 113]]] },
      { name: 'Philippines', points: [[18, 120], [16, 124], [12, 126], [8, 124], [10, 120], [14, 119]] },
      { name: 'Japan', points: [[45, 141], [41, 142], [36, 139], [31, 131], [34, 130], [39, 136]] },
      { name: 'Australia', points: [[-10, 113], [-12, 135], [-24, 154], [-39, 146], [-36, 117], [-23, 112]] },
      { name: 'New Zealand', points: [[-34, 166], [-38, 178], [-45, 171], [-42, 166]] }
    ];
    var countryLabels = [
      { label: 'Europe', lat: 52, lng: 18 },
      { label: 'KSA', lat: 23, lng: 45 },
      { label: 'UAE', lat: 24, lng: 54 },
      { label: 'Qatar', lat: 25, lng: 51 },
      { label: 'Bahrain', lat: 26, lng: 50 },
      { label: 'India', lat: 21, lng: 78 },
      { label: 'China', lat: 35, lng: 105 },
      { label: 'Thailand', lat: 15, lng: 101 },
      { label: 'Malaysia', lat: 4, lng: 102 },
      { label: 'Vietnam', lat: 15, lng: 108 },
      { label: 'Philippines', lat: 13, lng: 122 },
      { label: 'Japan', lat: 37, lng: 139 },
      { label: 'Australia', lat: -24, lng: 134 },
      { label: 'New Zealand', lat: -41, lng: 173 }
    ];

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function toRad(value) {
      return value * Math.PI / 180;
    }

    function matches(point) {
      return state.filter === 'all' || point.group.split(' ').indexOf(state.filter) !== -1;
    }

    function project(lat, lng) {
      var phi = toRad(lat);
      var lambda = toRad(lng - state.centerLng);
      var phi0 = toRad(state.centerLat);
      var cosPhi = Math.cos(phi);
      var sinPhi = Math.sin(phi);
      var cosLambda = Math.cos(lambda);
      var x = cosPhi * Math.sin(lambda);
      var y = sinPhi * Math.cos(phi0) - cosPhi * cosLambda * Math.sin(phi0);
      var z = sinPhi * Math.sin(phi0) + cosPhi * cosLambda * Math.cos(phi0);

      return {
        x: state.cx + state.radius * x,
        y: state.cy - state.radius * y,
        z: z,
        visible: z > 0
      };
    }

    function setCanvasSize() {
      var rect = canvas.getBoundingClientRect();
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      var width = Math.max(320, Math.round(rect.width));
      var height = Math.max(420, Math.round(rect.height));

      if (canvas.width !== Math.round(width * ratio) || canvas.height !== Math.round(height * ratio)) {
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
      }

      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      state.width = width;
      state.height = height;
      state.cx = width * 0.5;
      state.cy = height * 0.51;
      state.radius = Math.min(width, height) * 0.42 * state.zoom;
    }

    function updateZoomControls() {
      zoomControls.forEach(function (button) {
        var action = button.dataset.globeZoom;
        if (action === 'out') button.disabled = state.zoom <= 1.01;
        if (action === 'in') button.disabled = state.zoom >= 2.49;
      });
    }

    function setZoom(value, focusActive) {
      state.zoom = clamp(value, 1, 2.5);

      if (focusActive && state.active) {
        state.centerLng = state.active.lng;
        state.centerLat = clamp(state.active.lat, -48, 52);
      }

      updateZoomControls();
      draw();
    }

    function pathFromGeo(points, closePath) {
      var open = false;
      var drawn = false;

      points.forEach(function (point) {
        var projected = project(point[0], point[1]);
        if (projected.visible) {
          if (!open) {
            context.moveTo(projected.x, projected.y);
            open = true;
          } else {
            context.lineTo(projected.x, projected.y);
          }
          drawn = true;
        } else {
          open = false;
        }
      });

      if (closePath && drawn) context.closePath();
      return drawn;
    }

    function drawGeoLine(points, color, width, dash) {
      context.save();
      context.beginPath();
      if (pathFromGeo(points, false)) {
        context.strokeStyle = color;
        context.lineWidth = width;
        if (dash) context.setLineDash(dash);
        context.stroke();
      }
      context.restore();
    }

    function drawGraticule() {
      var lat;
      var lng;
      var line;

      for (lat = -60; lat <= 60; lat += 20) {
        line = [];
        for (lng = -180; lng <= 180; lng += 4) line.push([lat, lng]);
        drawGeoLine(line, 'rgba(247, 240, 226, 0.14)', 1, null);
      }

      for (lng = -180; lng < 180; lng += 20) {
        line = [];
        for (lat = -80; lat <= 80; lat += 4) line.push([lat, lng]);
        drawGeoLine(line, 'rgba(247, 240, 226, 0.1)', 1, null);
      }
    }

    function drawLand() {
      context.save();
      context.fillStyle = 'rgba(207, 199, 169, 0.28)';
      context.strokeStyle = 'rgba(255, 249, 236, 0.34)';
      context.lineWidth = globeCountries.length ? 0.75 : 1;
      context.shadowColor = 'rgba(255, 249, 236, 0.1)';
      context.shadowBlur = 6;

      if (globeCountries.length) {
        globeCountries.forEach(function (country) {
          country.rings.forEach(function (ring) {
            context.beginPath();
            if (pathFromGeo(ring, true)) {
              context.fill();
              context.stroke();
            }
          });
        });
      } else {
        landMasses.forEach(function (mass) {
          context.beginPath();
          if (pathFromGeo(mass.points, true)) {
            context.fill();
            context.stroke();
          }
        });
      }

      context.restore();
    }

    function drawOceanTexture() {
      context.save();
      context.globalAlpha = 0.28;
      context.strokeStyle = 'rgba(211, 232, 222, 0.2)';
      context.lineWidth = 1;

      [0.28, 0.42, 0.58, 0.72].forEach(function (scale, index) {
        context.beginPath();
        context.ellipse(
          state.cx + state.radius * (index % 2 ? 0.08 : -0.07),
          state.cy + state.radius * (index < 2 ? -0.05 : 0.08),
          state.radius * scale,
          state.radius * scale * 0.16,
          -0.36,
          0,
          Math.PI * 2
        );
        context.stroke();
      });

      context.restore();
    }

    function drawCountryLabels() {
      context.save();
      context.font = '800 10px Arial, sans-serif';
      context.textAlign = 'center';
      context.textBaseline = 'middle';

      countryLabels.forEach(function (item) {
        var projected = project(item.lat, item.lng);
        if (!projected.visible || projected.z < 0.18) return;
        context.globalAlpha = clamp(projected.z * 0.92, 0.28, 0.8);
        context.fillStyle = 'rgba(255, 253, 247, 0.92)';
        context.fillText(item.label, projected.x, projected.y);
      });

      context.restore();
    }

    function greatCircle(start, end) {
      var steps = 54;
      var points = [];
      var index;

      for (index = 0; index <= steps; index += 1) {
        var amount = index / steps;
        points.push([
          start.lat + (end.lat - start.lat) * amount,
          start.lng + (end.lng - start.lng) * amount
        ]);
      }

      return points;
    }

    function colorFor(point) {
      if (point.type === 'supply') return '#2e8e84';
      if (point.type === 'market') return '#b88545';
      return '#a94f3a';
    }

    function roundedRect(x, y, width, height, radius) {
      if (context.roundRect) {
        context.roundRect(x, y, width, height, radius);
        return;
      }

      context.moveTo(x + radius, y);
      context.lineTo(x + width - radius, y);
      context.quadraticCurveTo(x + width, y, x + width, y + radius);
      context.lineTo(x + width, y + height - radius);
      context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      context.lineTo(x + radius, y + height);
      context.quadraticCurveTo(x, y + height, x, y + height - radius);
      context.lineTo(x, y + radius);
      context.quadraticCurveTo(x, y, x + radius, y);
    }

    function drawRoutes() {
      routes.forEach(function (route) {
        var from = pointMap[route[0]];
        var to = pointMap[route[1]];
        if (!from || !to) return;
        if (!matches(from) && !matches(to) && state.filter !== 'all') return;
        drawGeoLine(greatCircle(from, to), 'rgba(184, 133, 69, 0.42)', 1.35, [5, 7]);
      });
    }

    function drawPoints() {
      points.forEach(function (point) {
        point.matches = matches(point);
        var projected = project(point.lat, point.lng);
        point.x = projected.x;
        point.y = projected.y;
        point.visible = projected.visible && point.matches;

        if (!point.visible) return;

        var active = state.active === point;
        context.save();
        context.globalAlpha = active ? 1 : 0.86;
        context.beginPath();
        context.arc(point.x, point.y, active ? 7 : 5, 0, Math.PI * 2);
        context.fillStyle = colorFor(point);
        context.fill();
        context.lineWidth = active ? 2.5 : 1.5;
        context.strokeStyle = active ? '#fff9ec' : 'rgba(255, 249, 236, 0.74)';
        context.stroke();

        if (active) {
          context.beginPath();
          context.arc(point.x, point.y, 16, 0, Math.PI * 2);
          context.strokeStyle = 'rgba(255, 249, 236, 0.36)';
          context.lineWidth = 1;
          context.stroke();
          drawLabel(point);
        }

        context.restore();
      });
    }

    function drawLabel(point) {
      var label = point.label || point.title;
      var paddingX = 9;
      context.save();
      context.font = '700 11px Arial, sans-serif';
      var width = Math.max(46, context.measureText(label).width + paddingX * 2);
      var x = clamp(point.x + 16, 14, state.width - width - 14);
      var y = clamp(point.y - 26, 14, state.height - 38);

      context.fillStyle = 'rgba(255, 249, 236, 0.94)';
      context.strokeStyle = 'rgba(16, 19, 15, 0.3)';
      context.lineWidth = 1;
      context.beginPath();
      roundedRect(x, y, width, 24, 12);
      context.fill();
      context.stroke();
      context.fillStyle = '#10130f';
      context.fillText(label, x + paddingX, y + 16);
      context.restore();
    }

    function draw() {
      setCanvasSize();
      updateZoomControls();
      context.clearRect(0, 0, state.width, state.height);

      var outer = context.createRadialGradient(state.cx - state.radius * 0.38, state.cy - state.radius * 0.42, state.radius * 0.1, state.cx, state.cy, state.radius * 1.12);
      outer.addColorStop(0, '#8aa69a');
      outer.addColorStop(0.34, '#31584d');
      outer.addColorStop(0.72, '#162a24');
      outer.addColorStop(1, '#07100d');

      context.save();
      context.shadowColor = 'rgba(0, 0, 0, 0.42)';
      context.shadowBlur = 50;
      context.beginPath();
      context.arc(state.cx, state.cy, state.radius, 0, Math.PI * 2);
      context.fillStyle = outer;
      context.fill();
      context.restore();

      context.save();
      context.beginPath();
      context.arc(state.cx, state.cy, state.radius, 0, Math.PI * 2);
      context.clip();
      drawOceanTexture();
      drawLand();
      drawGraticule();
      drawCountryLabels();
      drawRoutes();
      drawPoints();
      context.restore();

      context.save();
      var shade = context.createRadialGradient(state.cx - state.radius * 0.4, state.cy - state.radius * 0.42, state.radius * 0.2, state.cx, state.cy, state.radius * 1.04);
      shade.addColorStop(0, 'rgba(255, 253, 247, 0.18)');
      shade.addColorStop(0.52, 'rgba(255, 253, 247, 0.02)');
      shade.addColorStop(1, 'rgba(0, 0, 0, 0.32)');
      context.beginPath();
      context.arc(state.cx, state.cy, state.radius, 0, Math.PI * 2);
      context.fillStyle = shade;
      context.fill();
      context.restore();

      context.save();
      context.beginPath();
      context.arc(state.cx, state.cy, state.radius, 0, Math.PI * 2);
      context.strokeStyle = 'rgba(255, 253, 247, 0.34)';
      context.lineWidth = 1.6;
      context.stroke();
      context.beginPath();
      context.arc(state.cx, state.cy, state.radius + 4, 0, Math.PI * 2);
      context.strokeStyle = 'rgba(124, 171, 157, 0.18)';
      context.lineWidth = 8;
      context.stroke();
      context.restore();
    }

    function activate(point, rotateToPoint) {
      if (!point) return;
      state.active = point;

      buttons.forEach(function (button) {
        var isActive = button === point.button;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (kicker) kicker.textContent = point.kicker;
      if (title) title.textContent = point.title;
      if (copy) copy.textContent = point.copy;
      if (meta) meta.textContent = point.meta;
      if (activeLabel) activeLabel.textContent = point.title;

      if (rotateToPoint) {
        state.centerLng = point.lng;
        state.centerLat = clamp(point.lat, -38, 42);
      }

      draw();
    }

    function applyFilter(filter) {
      state.filter = filter || 'all';
      var view = filterViews[state.filter] || filterViews.all;
      state.centerLng = view.lng;
      state.centerLat = view.lat;
      state.zoom = view.zoom || 1;

      filters.forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.globeFilter === state.filter);
      });

      points.forEach(function (point) {
        var match = matches(point);
        point.button.hidden = !match;
        point.button.setAttribute('aria-hidden', String(!match));
      });

      if (!state.active || !matches(state.active)) {
        activate(points.find(matches), false);
      }

      draw();
    }

    function pickPoint(x, y) {
      var best = null;
      var bestDistance = 28;

      points.forEach(function (point) {
        if (!point.visible) return;
        var dx = point.x - x;
        var dy = point.y - y;
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = point;
        }
      });

      return best;
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(button.dataset.globeFilter || 'all');
      });
    });

    zoomControls.forEach(function (button) {
      button.addEventListener('click', function () {
        var action = button.dataset.globeZoom;

        if (action === 'in') {
          setZoom(state.zoom + 0.25, true);
          return;
        }

        if (action === 'out') {
          setZoom(state.zoom - 0.25, false);
          return;
        }

        if (action === 'reset') {
          var view = filterViews[state.filter] || filterViews.all;
          state.centerLng = view.lng;
          state.centerLat = view.lat;
          setZoom(view.zoom || 1, false);
        }
      });
    });

    points.forEach(function (point) {
      point.button.setAttribute('aria-pressed', String(point.button.classList.contains('is-active')));
      point.button.addEventListener('click', function () {
        if (!matches(point)) applyFilter('all');
        activate(point, true);
      });
    });

    canvas.addEventListener('pointerdown', function (event) {
      state.dragging = true;
      state.hasMoved = false;
      state.lastX = event.clientX;
      state.lastY = event.clientY;
      canvas.setPointerCapture(event.pointerId);
    });

    canvas.addEventListener('pointermove', function (event) {
      if (!state.dragging) return;
      var dx = event.clientX - state.lastX;
      var dy = event.clientY - state.lastY;
      if (Math.abs(dx) + Math.abs(dy) > 2) state.hasMoved = true;
      state.centerLng -= dx * (0.24 / state.zoom);
      state.centerLat = clamp(state.centerLat + dy * (0.18 / state.zoom), -55, 55);
      state.lastX = event.clientX;
      state.lastY = event.clientY;
      draw();
    });

    canvas.addEventListener('pointerup', function (event) {
      state.dragging = false;
      canvas.releasePointerCapture(event.pointerId);

      if (state.hasMoved) return;

      var rect = canvas.getBoundingClientRect();
      var point = pickPoint(event.clientX - rect.left, event.clientY - rect.top);
      if (point) activate(point, false);
    });

    canvas.addEventListener('mouseenter', function () {
      state.hover = true;
    });

    canvas.addEventListener('mouseleave', function () {
      state.hover = false;
      state.dragging = false;
    });

    window.addEventListener('resize', draw);

    if ('ResizeObserver' in window) {
      new ResizeObserver(draw).observe(canvas);
    }

    if (countrySource) {
      fetch(countrySource)
        .then(function (response) { return response.json(); })
        .then(function (countries) {
          globeCountries = Array.isArray(countries) ? countries : [];
          draw();
        })
        .catch(function () {
          globeCountries = [];
        });
    }

    activate(points.find(function (point) {
      return point.button.classList.contains('is-active');
    }) || points[0], false);

    draw();
  });

  document.querySelectorAll('[data-orn-archive]').forEach(function (archive) {
    var source = archive.dataset.source;
    var assetBase = archive.dataset.assetBase || '';
    var searchInput = archive.querySelector('[data-archive-search]');
    var categorySelect = archive.querySelector('[data-archive-category]');
    var regionSelect = archive.querySelector('[data-archive-region]');
    var eraSelect = archive.querySelector('[data-archive-era]');
    var status = archive.querySelector('[data-archive-status]');
    var results = archive.querySelector('[data-archive-results]');
    var viewButtons = Array.prototype.slice.call(archive.querySelectorAll('[data-archive-view]'));
    var records = [];
    var activeView = 'cards';

    function normalise(value) {
      return String(value || '').toLowerCase();
    }

    function uniqueValues(items, field) {
      return items.map(function (item) {
        return item[field];
      }).filter(Boolean).filter(function (value, index, list) {
        return list.indexOf(value) === index;
      }).sort();
    }

    function fillSelect(select, values) {
      if (!select) return;
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    }

    function imageUrl(record) {
      if (!record.image) return '';
      if (/^https?:\/\//.test(record.image) || record.image.charAt(0) === '/') return record.image;
      return assetBase + record.image;
    }

    function matchesFilters(record) {
      var query = normalise(searchInput ? searchInput.value : '').trim();
      var category = categorySelect ? categorySelect.value : 'all';
      var region = regionSelect ? regionSelect.value : 'all';
      var era = eraSelect ? eraSelect.value : 'all';
      var searchable = [
        record.title,
        record.year,
        record.era,
        record.category,
        record.region,
        record.project,
        record.summary,
        record.insight,
        record.status,
        record.sourceType,
        (record.plantTypes || []).join(' '),
        (record.tags || []).join(' ')
      ].join(' ');

      return (!query || normalise(searchable).indexOf(query) !== -1)
        && (category === 'all' || record.category === category)
        && (region === 'all' || record.region === region)
        && (era === 'all' || record.era === era);
    }

    function tagList(items) {
      var wrap = document.createElement('div');
      wrap.className = 'or10-archive-card__tags';
      (items || []).slice(0, 5).forEach(function (item) {
        var tag = document.createElement('span');
        tag.textContent = item;
        wrap.appendChild(tag);
      });
      return wrap;
    }

    function card(record) {
      var article = document.createElement('article');
      article.className = 'or10-archive-card';
      var media = document.createElement('div');
      media.className = 'or10-archive-card__media';
      var src = imageUrl(record);

      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = record.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'or10-archive-card__body';
      var eyebrow = document.createElement('small');
      eyebrow.textContent = [record.category, record.region, record.year].filter(Boolean).join(' / ');
      var heading = document.createElement('h3');
      heading.textContent = record.title || 'Archive record';
      var summary = document.createElement('p');
      summary.textContent = record.summary || '';
      var insight = document.createElement('blockquote');
      insight.textContent = record.insight || '';
      var meta = document.createElement('div');
      meta.className = 'or10-archive-card__meta';
      [record.project || 'Multiple projects', record.status || 'Archive record'].forEach(function (value) {
        var span = document.createElement('span');
        span.textContent = value;
        meta.appendChild(span);
      });

      body.appendChild(eyebrow);
      body.appendChild(heading);
      body.appendChild(summary);
      if (record.insight) body.appendChild(insight);
      body.appendChild(tagList([].concat(record.plantTypes || [], record.tags || [])));
      body.appendChild(meta);

      if (record.sourceUrl) {
        var link = document.createElement('a');
        link.href = record.sourceUrl;
        link.textContent = 'Open source record';
        body.appendChild(link);
      }

      article.appendChild(media);
      article.appendChild(body);
      return article;
    }

    function table(recordsToRender) {
      var tableWrap = document.createElement('div');
      tableWrap.className = 'or10-archive-table';
      var table = document.createElement('table');
      table.innerHTML = '<thead><tr><th>Record</th><th>Year</th><th>Region</th><th>Category</th><th>Project</th></tr></thead>';
      var tbody = document.createElement('tbody');

      recordsToRender.forEach(function (record) {
        var row = document.createElement('tr');
        [record.title, record.year, record.region, record.category, record.project].forEach(function (value) {
          var cell = document.createElement('td');
          cell.textContent = value || '';
          row.appendChild(cell);
        });
        tbody.appendChild(row);
      });

      table.appendChild(tbody);
      tableWrap.appendChild(table);
      return tableWrap;
    }

    function render() {
      var filtered = records.filter(matchesFilters);
      if (status) {
        status.textContent = filtered.length + ' archive records. Replace the starter JSON with scanned-document records when ready.';
      }
      if (!results) return;

      results.innerHTML = '';
      results.classList.toggle('or10-archive__results--table', activeView === 'table');

      if (!filtered.length) {
        var empty = document.createElement('p');
        empty.className = 'or10-archive-empty';
        empty.textContent = 'No archive records match that search yet.';
        results.appendChild(empty);
        return;
      }

      if (activeView === 'table') {
        results.appendChild(table(filtered));
      } else {
        filtered.forEach(function (record) {
          results.appendChild(card(record));
        });
      }
    }

    [searchInput, categorySelect, regionSelect, eraSelect].forEach(function (control) {
      if (!control) return;
      control.addEventListener('input', render);
      control.addEventListener('change', render);
    });

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeView = button.dataset.archiveView || 'cards';
        viewButtons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        render();
      });
    });

    if (source) {
      runWhenVisible(archive, function () {
        fetch(source)
          .then(function (response) { return response.json(); })
          .then(function (items) {
            records = Array.isArray(items) ? items : [];
            fillSelect(categorySelect, uniqueValues(records, 'category'));
            fillSelect(regionSelect, uniqueValues(records, 'region'));
            fillSelect(eraSelect, uniqueValues(records, 'era'));
            render();
          })
          .catch(function () {
            if (status) status.textContent = 'Archive records could not be loaded.';
          });
      });
    }
  });

  document.querySelectorAll('[data-orn-species-atlas]').forEach(function (atlas) {
    var source = atlas.dataset.source;
    var contactUrl = atlas.dataset.contactUrl || '/pages/contact-us';
    var searchInput = atlas.querySelector('[data-species-search]');
    var filters = Array.prototype.slice.call(atlas.querySelectorAll('[data-species-filter]'));
    var results = atlas.querySelector('[data-species-results]');
    var status = atlas.querySelector('[data-species-status]');
    var moreButton = atlas.querySelector('[data-species-more]');
    var allItems = [];
    var filteredItems = [];
    var activeFilter = 'all';
    var visibleCount = 12;
    var atlasParams = new URLSearchParams(window.location.search);
    var initialAtlasQuery = atlasParams.get('atlas') || atlasParams.get('q') || '';

    if (searchInput && initialAtlasQuery) {
      searchInput.value = initialAtlasQuery;
    }

    function normalise(value) {
      return String(value || '').toLowerCase();
    }

    function matchesFilter(item) {
      if (activeFilter === 'all') return true;
      var tags = (item.tags || []).map(normalise);
      return normalise(item.kind) === activeFilter || tags.indexOf(activeFilter) !== -1;
    }

    function matchesSearch(item) {
      var query = normalise(searchInput ? searchInput.value : '').trim();
      if (!query) return true;
      var haystack = [
        item.title,
        item.botanical,
        item.common,
        item.kind,
        (item.tags || []).join(' '),
        item.excerpt
      ].join(' ').toLowerCase();
      return haystack.indexOf(query) !== -1;
    }

    function card(item) {
      var article = document.createElement('article');
      article.className = 'or6-species-card';

      if (item.image) {
        var media = document.createElement('div');
        media.className = 'or6-species-card__media';
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        img.onerror = function () {
          media.hidden = true;
        };
        media.appendChild(img);
        article.appendChild(media);
      }

      var body = document.createElement('div');
      body.className = 'or6-species-card__body';
      var kind = document.createElement('small');
      kind.textContent = item.kind || 'Plant option';
      var heading = document.createElement('h3');
      heading.textContent = item.botanical || item.title || 'Plant option';
      body.appendChild(kind);
      body.appendChild(heading);

      if (item.common) {
        var common = document.createElement('p');
        common.className = 'or6-species-card__common';
        common.textContent = item.common;
        body.appendChild(common);
      }

      var usefulTags = (item.tags || []).filter(function (tag) {
        return tag && tag.toLowerCase() !== 'poa';
      }).slice(0, 5);
      if (usefulTags.length) {
        var tagWrap = document.createElement('div');
        tagWrap.className = 'or6-species-card__tags';
        usefulTags.forEach(function (tag) {
          var span = document.createElement('span');
          span.textContent = tag;
          tagWrap.appendChild(span);
        });
        body.appendChild(tagWrap);
      }

      if (item.height || item.width) {
        var size = document.createElement('p');
        size.className = 'or6-species-card__size';
        size.textContent = 'Reference size: ' + (item.height ? item.height + 'm high' : 'height varies') + ' / ' + (item.width ? item.width + 'm wide' : 'width varies');
        body.appendChild(size);
      }

      if (item.excerpt) {
        var excerpt = document.createElement('p');
        excerpt.className = 'or6-species-card__excerpt';
        excerpt.textContent = item.excerpt;
        body.appendChild(excerpt);
      }

      var link = document.createElement('a');
      link.href = contactUrl + '?species=' + encodeURIComponent(item.title || item.handle || '');
      link.textContent = 'Ask about this option';
      body.appendChild(link);
      article.appendChild(body);
      return article;
    }

    function render() {
      filteredItems = allItems.filter(function (item) {
        return matchesFilter(item) && matchesSearch(item);
      });

      results.innerHTML = '';
      filteredItems.slice(0, visibleCount).forEach(function (item) {
        results.appendChild(card(item));
      });

      if (status) {
        status.textContent = filteredItems.length + ' matching plant options. Availability is confirmed by project enquiry.';
      }
      if (moreButton) {
        moreButton.hidden = filteredItems.length <= visibleCount;
      }
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = button.dataset.speciesFilter || 'all';
        visibleCount = 12;
        filters.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        render();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        visibleCount = 12;
        render();
      });
    }

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        visibleCount += 12;
        render();
      });
    }

    if (source && results) {
      runWhenVisible(atlas, function () {
        fetch(source)
          .then(function (response) { return response.json(); })
          .then(function (items) {
            allItems = Array.isArray(items) ? items : [];
            render();
          })
          .catch(function () {
            if (status) status.textContent = 'Species options could not be loaded. Send your plant schedule for availability.';
          });
      });
    }
  });
});
